export enum Role {
  CUSTOMER_ADMIN = "CUSTOMER_ADMIN",
  ONE_ADMIN = "ONE_ADMIN",
  ONE_USER_ADMIN = "ONE_USER_ADMIN",
  ONE_USER = "ONE_USER",
  USER = "USER",
}
